import { get } from '@api/api';
import { IFeatureFlag } from '@api/featureFlags/types/IFeatureFlags';

export function getFeatureFlagAndEnablersById(id: string) {
  return get<IFeatureFlag>(`/feature-flags/${id}`);
}
